/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CabinClassTTLOCriteriaInput,
    CabinClassTTLOCriteriaInputFromJSON,
    CabinClassTTLOCriteriaInputFromJSONTyped,
    CabinClassTTLOCriteriaInputToJSON,
    CharTTLOCriteriaInput,
    CharTTLOCriteriaInputFromJSON,
    CharTTLOCriteriaInputFromJSONTyped,
    CharTTLOCriteriaInputToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    JourneyTTLOCriteriaInput,
    JourneyTTLOCriteriaInputFromJSON,
    JourneyTTLOCriteriaInputFromJSONTyped,
    JourneyTTLOCriteriaInputToJSON,
    StringTTLOCriteriaInput,
    StringTTLOCriteriaInputFromJSON,
    StringTTLOCriteriaInputFromJSONTyped,
    StringTTLOCriteriaInputToJSON,
    TTLOCriteriaForRouteRequest,
    TTLOCriteriaForRouteRequestFromJSON,
    TTLOCriteriaForRouteRequestFromJSONTyped,
    TTLOCriteriaForRouteRequestToJSON,
    TTLODateTimeRestriction,
    TTLODateTimeRestrictionFromJSON,
    TTLODateTimeRestrictionFromJSONTyped,
    TTLODateTimeRestrictionToJSON,
    TTLOTravelDateRange,
    TTLOTravelDateRangeFromJSON,
    TTLOTravelDateRangeFromJSONTyped,
    TTLOTravelDateRangeToJSON,
    TicketTimeLimitOverrideTimeConfigItem,
    TicketTimeLimitOverrideTimeConfigItemFromJSON,
    TicketTimeLimitOverrideTimeConfigItemFromJSONTyped,
    TicketTimeLimitOverrideTimeConfigItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideConfig
 */
export interface TicketTimeLimitOverrideConfig {
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideConfig
     */
    id?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TicketTimeLimitOverrideConfig
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    suppliers?: Array<string> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {TicketTimeLimitOverrideTimeConfigItem}
     * @memberof TicketTimeLimitOverrideConfig
     */
    time?: TicketTimeLimitOverrideTimeConfigItem;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideConfig
     */
    dayOffset?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideConfig
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof TicketTimeLimitOverrideConfig
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketTimeLimitOverrideConfig
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    channels?: Array<number> | null;
    /**
     * 
     * @type {Array<StringTTLOCriteriaInput>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    accountCodes?: Array<StringTTLOCriteriaInput> | null;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideConfig
     */
    relevance?: number;
    /**
     * 
     * @type {Array<JourneyTTLOCriteriaInput>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    journeyTypes?: Array<JourneyTTLOCriteriaInput> | null;
    /**
     * 
     * @type {Array<CabinClassTTLOCriteriaInput>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    cabinClasses?: Array<CabinClassTTLOCriteriaInput> | null;
    /**
     * 
     * @type {Array<CharTTLOCriteriaInput>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    bookingClasses?: Array<CharTTLOCriteriaInput> | null;
    /**
     * 
     * @type {Array<TTLOCriteriaForRouteRequest>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    routes?: Array<TTLOCriteriaForRouteRequest> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    agencies?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    agencyGroups?: Array<string> | null;
    /**
     * 
     * @type {Array<TTLODateTimeRestriction>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    dateTimeRestrictions?: Array<TTLODateTimeRestriction> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof TicketTimeLimitOverrideConfig
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<TTLOTravelDateRange>}
     * @memberof TicketTimeLimitOverrideConfig
     */
    travelDates?: Array<TTLOTravelDateRange> | null;
}

export function TicketTimeLimitOverrideConfigFromJSON(json: any): TicketTimeLimitOverrideConfig {
    return TicketTimeLimitOverrideConfigFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'suppliers': !exists(json, 'suppliers') ? undefined : json['suppliers'],
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'time': !exists(json, 'time') ? undefined : TicketTimeLimitOverrideTimeConfigItemFromJSON(json['time']),
        'dayOffset': !exists(json, 'dayOffset') ? undefined : json['dayOffset'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'channels': !exists(json, 'channels') ? undefined : json['channels'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringTTLOCriteriaInputFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTTLOCriteriaInputFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassTTLOCriteriaInputFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharTTLOCriteriaInputFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(TTLOCriteriaForRouteRequestFromJSON)),
        'agencies': !exists(json, 'agencies') ? undefined : json['agencies'],
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : json['agencyGroups'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(TTLODateTimeRestrictionFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(TTLOTravelDateRangeFromJSON)),
    };
}

export function TicketTimeLimitOverrideConfigToJSON(value?: TicketTimeLimitOverrideConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'fareTypes': value.fareTypes,
        'suppliers': value.suppliers,
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'time': TicketTimeLimitOverrideTimeConfigItemToJSON(value.time),
        'dayOffset': value.dayOffset,
        'enabled': value.enabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'channels': value.channels,
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringTTLOCriteriaInputToJSON)),
        'relevance': value.relevance,
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTTLOCriteriaInputToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassTTLOCriteriaInputToJSON)),
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharTTLOCriteriaInputToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(TTLOCriteriaForRouteRequestToJSON)),
        'agencies': value.agencies,
        'agencyGroups': value.agencyGroups,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(TTLODateTimeRestrictionToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(TTLOTravelDateRangeToJSON)),
    };
}


